import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
    , Button
    , TextField
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'

import Application from '../components/app/Application';

interface Props extends WithTranslation
{
}
interface State
{
    src,
    crop: {
        x, y, width, height,
    }
}

/**
 * @author Germán Martínez
 */
class RouteToolsImageCrop extends React.Component<Props,State>
{
    state: State =
    {
        src: null,
        crop: {
            x: 10,
            y: 10,
            width: 80,
            height: 80,
        },
    }
    fileUrl = null;
    imageRef = null;

    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/image-crop'>{t('toolImageCrop.title')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('toolImageCrop.title')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <input className="form-control" type="file" onChange={this.onSelectFile} />
                </FormGroup>
            </div>
        </div>
        <div className="row">
            <div className="col">
                {this.state.src && (
                <ReactCrop
                    src={this.state.src}
                    crop={this.state.crop}
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                />
                )}
            </div>
            <div className="col-3">
                <FormGroup>
                    <label>X</label>
                    <TextField
                        type="number"
                        value={this.state.crop.x}
                        disabled={this.state.src == null}
                        onChange={(e) =>
                        {
                            this.setState({
                                crop: { ... this.state.crop, x: e.target.value }
                            })
                        }}
                    />
                </FormGroup>
                <FormGroup>
                    <label>Y</label>
                    <TextField
                        type="number"
                        value={this.state.crop.y}
                        disabled={this.state.src == null}
                        onChange={(e) =>
                        {
                            this.setState({
                                crop: { ... this.state.crop, y: e.target.value }
                            })
                        }}
                    />
                </FormGroup>
                <FormGroup>
                    <label>{t('toolImageCrop.widthLabel')}</label>
                    <TextField
                        type="number"
                        value={this.state.crop.width}
                        disabled={this.state.src == null}
                        onChange={(e) =>
                        {
                            this.setState({
                                crop: { ... this.state.crop, width: e.target.value }
                            })
                        }}
                    />
                </FormGroup>
                <FormGroup>
                    <label>{t('toolImageCrop.heightLabel')}</label>
                    <TextField
                        type="number"
                        value={this.state.crop.height}
                        disabled={this.state.src == null}
                        onChange={(e) =>
                        {
                            this.setState({
                                crop: { ... this.state.crop, height: e.target.value }
                            })
                        }}
                    />
                </FormGroup>
                
                <FormGroup>
                    <Button
                        color="primary"
                        disabled={this.state.src == null}
                        fullwidth={true}
                        onClick={() =>
                        {
                            if(this.imageRef && this.state.crop.width && this.state.crop.height)
                            {
                                this.getCroppedImg(this.imageRef, this.state.crop, 'cropped.png').then((croppedImageUrl) =>
                                {
                                    var a = document.createElement('a');
                                    var url: any = croppedImageUrl;
                                    a.href = url;
                                    a.download = 'cropped.png';
                                    document.body.append(a);
                                    a.click();
                                    a.remove();
                                    window.URL.revokeObjectURL(url);
                                });
                            }
                        }}
                    >
                        {t('toolImageCrop.cropButton')}
                    </Button>
                </FormGroup>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    onSelectFile = (e) =>
    {
        if(e.target.files && e.target.files.length > 0)
        {
            const reader = new FileReader()
            
            reader.addEventListener(
                'load',
                () =>
                {
                    this.setState({
                        src: reader.result,
                    });
                },
                false
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    onImageLoaded = (image) =>
    {
        console.log('onCropComplete', image)
        this.imageRef = image;

        const imageWidth = image.width;
        const imageHeight = image.height;
        const w = imageWidth/2;
        const h = imageHeight/2;
        const x = (imageWidth-w)/2;
        const y = (imageHeight-h)/2;

        this.setState({
            crop: {
                x,
                y,
                width: w,
                height: h,
                //unit: '%',
                //aspect,
            }
        });
        return false;
    }
    
    onCropComplete = (crop) =>
    {
        console.log('onCropComplete', crop)
    }

    onCropChange = (crop) =>
    {
        console.log('onCropChange', crop)
        this.setState({
            crop: {
                x: Math.round(crop.x),
                y: Math.round(crop.y),
                width: Math.round(crop.width),
                height: Math.round(crop.height),
        } })
    }

    getCroppedImg(image, crop, fileName)
    {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob:any) =>
            {
                blob.name = fileName; // eslint-disable-line no-param-reassign
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
            }, 'image/png');
        });
    }

}
export default withTranslation('common')(RouteToolsImageCrop);

